(() => {
  function initHero(root) {
    const slides = [...root.querySelectorAll('[data-eniola-exact-slide]')];
    const dots = [...root.querySelectorAll('[data-eniola-exact-dot]')];
    if (slides.length < 2) return;

    let current = 0;
    let timer;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.style.opacity = i === current ? '1' : '0'; });
      dots.forEach((dot, i) => {
        dot.style.background = i === current ? 'rgb(102, 15, 52)' : 'rgba(34, 36, 42, 0.3)';
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    };
    const restart = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => show(current + 1), 6000);
    };

    root.querySelector('[data-eniola-exact-prev]')?.addEventListener('click', () => { show(current - 1); restart(); });
    root.querySelector('[data-eniola-exact-next]')?.addEventListener('click', () => { show(current + 1); restart(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); restart(); }));
    show(0);
    restart();
  }

  function initLexicon() {
    const input = document.querySelector('[data-eniola-exact-search]');
    const resultCount = document.querySelector('[data-eniola-lex-count]');
    const groups = [...document.querySelectorAll('[data-eniola-lex-group]')];
    if (!input || !groups.length || input.dataset.eniolaReady === 'true') return;
    input.dataset.eniolaReady = 'true';
    const normalize = (value) => value.toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const filter = () => {
      const query = normalize(input.value.trim());
      let count = 0;
      groups.forEach((group) => {
        const cards = [...group.querySelectorAll('[data-eniola-lex-card]')];
        let visible = 0;
        cards.forEach((card) => {
          const match = !query || normalize(card.textContent || '').includes(query);
          card.hidden = !match;
          if (match) visible += 1;
        });
        group.hidden = visible === 0;
        count += visible;
      });
      if (resultCount) resultCount.textContent = String(count);
    };

    input.addEventListener('input', filter);
    filter();
  }

  function initProduct(root) {
    const price = root.querySelector('[data-eniola-exact-price]');
    const addLabel = root.querySelector('[data-eniola-exact-add-label]');
    root.querySelectorAll('[data-eniola-exact-variant]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        const value = radio.dataset.price || '';
        if (price) price.textContent = value;
        if (addLabel) addLabel.textContent = `${addLabel.dataset.prefix || 'In den Warenkorb'} — ${value}`;
      });
    });
  }

  function initShopCards(scope) {
    scope.querySelectorAll('.eniola-exact--shop [style*="cursor: pointer"], .eniola-exact--home [style*="cursor: pointer"]').forEach((card) => {
      if (card.dataset.eniolaShopCard === 'true' || !card.querySelector('.eniola-exact__image, .eniola-exact__placeholder')) return;
      if (!/(Einzelflasche|Family Pack|Routine-Abo)/i.test(card.textContent || '')) return;
      card.dataset.eniolaShopCard = 'true';
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      const open = () => { window.location.href = '/products/einzelflasche'; };
      card.addEventListener('click', (event) => {
        if (event.target.closest('a, button, input, select, textarea')) return;
        open();
      });
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-eniola-exact-hero]').forEach(initHero);
    initLexicon();
    scope.querySelectorAll('[data-eniola-exact-product]').forEach(initProduct);
    initShopCards(scope);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-eniola-coupon-open]')) {
      document.querySelector('[data-eniola-coupon-dialog]')?.showModal();
    }
    if (event.target.closest('[data-eniola-coupon-close]')) {
      document.querySelector('[data-eniola-coupon-dialog]')?.close();
    }
  });

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
